import React, { useState, useEffect } from "react";
import "./GoalsDashboard.css";
import { useHistory } from "react-router-dom";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import { GoalsReport } from "../GoalDashboardComponent/GoalsReport";
import { GoalsDetails } from "../GoalDashboardComponent/GoalsDetails";
import filterIcon from "../../../assets/images/budget/filter.png";
import { Menu, Dropdown } from "antd";
import moment from "moment";
import FETCH from "../../../utils/fetch";
import { MODULE_API } from "../../../apis";
import swal from "sweetalert";
export const GoalsDashboard = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [goalsData, setGoalsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const getGoalsList = async (page) => {
    try {
      setLoading(true);
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id: `?module=Goals&page=${page}&limit=10`,
        body: {},
      });
      if (datares && datares.records) {
        // setGoalsData(datares.records);
        console.log("datares.records",datares.records)
        setGoalsData((prevItems) => [...prevItems, ...datares.records]);
        setTotalPages(Math.ceil(datares.pagination.total && datares.pagination.total / 10));
        setCurrentPage(page);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    let isMounted = true; //
    getGoalsList(1);
    return () => {
      isMounted = false; // Cleanup function to set isMounted to false when unmounted
    };
  }, []);
  const deleteGoal = async (id,record) => {
    // console.log("iddddd",id,record)
    swal({
      title: "Confirm Delete",
      content: {
        element: "div",
        attributes: {
          innerHTML: `<div style="color: "#000000a6";">This will delete <strong>${record["Description of Goal"] ? record["Description of Goal"] : "Goal"}</strong></div>`
        },
      },
      // text: `This will delete <strong>${record["Description of Goal"] ? record["Description of Goal"] : "Goal"}</strong>`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (result) => {
      if (result === true) {
        try {
          setLoading(true);
          const res = await MODULE_API.removeClientModule({
            clientModules: [id],
          });
          if(record.hasOwnProperty("loan_id")){
            await MODULE_API.removeClientModule({
              clientModules: [record["loan_id"]],
            });
          }
          if(record.hasOwnProperty("assignAssets")){
            let assetsToUpdateId=record["asset_id"];
            let assetsToUpdate={
              clientModuleIds: assetsToUpdateId,
              goalId: id
            }
            if(assetsToUpdateId){
              // Call the API with the goal_id and the current moduleId
              await MODULE_API.deleteAssetGoal(assetsToUpdate);
            }
          }
          setGoalsData([]);
          setLoading(false);
          getGoalsList(1);
          return res;
        } catch (error) {
          setLoading(false);
        }
      }
    });
  };
  const sortData = (sortBy) => {
    let sortedData;
    switch (sortBy) {
      case "closest":
        sortedData =
          goalsData &&
          [...goalsData].sort((a, b) => {
            if (a["Amount Needed in Future with Inflation"] !== undefined && b["Dollar Amount Needed"] !== undefined) {
              return a["Dollar Amount Needed"] - b["Dollar Amount Needed"];
            } else {
              return 0; // No sorting if amountNeeded is missing
            }
          });
        break;
      case "soonest":
        sortedData =
          goalsData &&
          [...goalsData].sort((a, b) => {
            if (a["Goal Date"] && b["Goal Date"]) {
              return (
                moment(a["Goal Date"], "DD-MM-YYYY") - moment(b["Goal Date"], "DD-MM-YYYY")
              );
            } else {
              return 0; // No sorting if date is missing
            }
          });
        break;
      case "largest":
        sortedData =
          goalsData &&
          [...goalsData].sort((a, b) => {
            if (a["Amount Needed in Future with Inflation"] !== undefined && b["Amount Needed in Future with Inflation"] !== undefined) {
              return b["Amount Needed in Future with Inflation"] - a["Amount Needed in Future with Inflation"];
            } else {
              return 0; // No sorting if amountHave is missing
            }
          });
        break;
      case "smallest":
        sortedData =
          goalsData &&
          [...goalsData].sort((a, b) => {
            if (a["Amount Needed in Future with Inflation"] !== undefined && b["Amount Needed in Future with Inflation"] !== undefined) {
              return a["Amount Needed in Future with Inflation"] - b["Amount Needed in Future with Inflation"];
            } else {
              return 0; // No sorting if amountHave is missing
            }
          });
        break;
      default:
        sortedData = goalsData && [...goalsData];
    }
    setGoalsData(sortedData);
  };
  const handleScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } =
      document.getElementById("goalsDisplay");
    // console.log("Scroll Top:", scrollTop);
    // console.log("Scroll Height:", scrollHeight);
    // console.log("Client Height:", clientHeight);

    if (scrollTop + clientHeight >= scrollHeight) {
      // console.log("Bottom of the scroll reached.");
      // console.log("pageee", currentPage, totalPages);
      if (currentPage < totalPages) {
        console.log("Fetching more items...");
        getGoalsList(currentPage + 1);
      }
    }
  };
  return (
    <div className="goalsMain">
      <div className="goalCreate" style={{ justifyContent: "space-between" }}>
        <h3 className="BudgetReportheading">Goals</h3>
        <div className="budgetcreate" style={{ gap: "1rem" }}>
          <div className="filterIcons">
            <Dropdown
              trigger={["click"]}
              overlay={
                <Menu>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        sortData("soonest");
                      }}
                    >
                      Soonest
                    </div>
                  </Menu.Item>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        sortData("closest");
                      }}
                    >
                      Closest
                    </div>
                  </Menu.Item>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        sortData("largest");
                      }}
                    >
                      Largest
                    </div>
                  </Menu.Item>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        sortData("smallest");
                      }}
                    >
                      Smallest
                    </div>
                  </Menu.Item>
                </Menu>
              }
            >
              <a
                className="ant-dropdown-link"
                onClick={(e) => e.preventDefault()}
              >
                <img src={filterIcon} height={24} width={24} alt="icon"></img>
              </a>
            </Dropdown>{" "}
          </div>
          <button
            className="addbuttonGoal"
            onClick={() => {
              history.push("/goals_add");
            }}
          >
            {" "}
            + Add Goal
          </button>
        </div>
      </div>
      <div className="dashboardMainGoal">
        <GoalsReport goalsData={goalsData && goalsData} />
      </div>
      <div id="goalsDisplay"
      onScroll={handleScroll}>
      {goalsData && goalsData.length>0 &&
        goalsData.map((item, index) => (
          <div
            className="dashboardMainGoal"
            style={{ marginTop: "1rem", position:"relative" }}
            key={index}
          >
            <GoalsDetails data={item} keyIndex={index} deleteGoal={deleteGoal} />
            <NewLoader isLoading={loading} />
          </div>
        ))}
        </div>
        <NewLoader isLoading={loading}/>
    </div>
  );
};
